import { useState } from "react";
import CommCard from "src/common/CommCard";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import B2BFilterSelect from "./B2BFilterSelect";
import B2BLedgerTable from "./B2BLedgerTable";
import type { TB2BLedger } from "./type/reportType";

const B2BLedger = () => {
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [b2bId, setB2bId] = useState<number | string>("");
	const [searchParams, setSearchParams] = useState({ name: "" });
	const { data, isLoading } = useGetQueryWithTotal<TB2BLedger[]>({
		endPoint: "/api/admin/reports/b2b-ledger",
		queryKeys: ["b2b-ledger", b2bId],
		params: {
			name: searchParams.name || undefined,
			b2b_id: b2bId || undefined,
			dateRange,
		},
	});

	return (
		<>
			<CommCard
				showCardHeader
				showDateRange
				headerTitle='B2B Ledger List'
				handleSearchFun={(name) =>
					setSearchParams((prev) => ({ ...prev, name }))
				}
				handleDateRange={(date) => {
					setDateRange(date);
				}}
				helmetTitle='BTTF - B2B Ledger list'
				componentChildren={
					<B2BFilterSelect
						value={b2bId}
						onChange={(id) => setB2bId(id)}
					/>
				}
			>
				<B2BLedgerTable data={data?.data || []} isLoading={isLoading} />
			</CommCard>
		</>
	);
};
export default B2BLedger;
